import React from 'react';
import Helmet from 'react-helmet';

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

import './contacts.scss';

const MapWithAMarker = withScriptjs(withGoogleMap(({ marker, zoom }) => (
  <GoogleMap defaultZoom={zoom} defaultCenter={marker}>
    <Marker position={marker} />
  </GoogleMap>
)));

const IndexPage = ({ pathContext: { content } }) => {
  const markerPos = {
    lat: 57.3639875,
    lng: 24.9797047,
  };
  const zoom = 11;

  const page = content.pages.contacts;

  const meta = [];
  if (page.description) {
    meta.push({ name: 'description', content: page.description });
  }
  if (page.keywords) {
    meta.push({ name: 'keywords', content: page.keywords });
  }

  return (
    <div className="page content contacts-page">
      <Helmet title={`${content.pages.contacts.title} | ${content.title}`} meta={meta} />
      <div className="page-title">{page.pageTitle}</div>
      <div className="flex-content">
        <div className="info-block">
          <div className="company">{content.company}</div>
          <div className="address">{content.address}</div>
          <hr />
          <div className="contacts">
            <div className="info">{page.info}</div>
            <div className="label">{page.phoneLabel}</div>
            <ul>{content.phones.map((phone, i) => <li key={i}>{phone}</li>)}</ul>
            {page.emailLabel && page.emails.length ? (
              <div>
                <div className="label">{page.emailLabel}</div>
                <ul>
                  {page.emails.map((email, i) => (
                    <li key={i}>
                      <a href={`mailto:${email}`}>{email}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          {/* <hr />
          <div className="working-hours">
            Regulārais darba laiks?
            <table>
              <tr>
                <td>Pirmdiena</td><td> 13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Otrdiena </td><td>13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Trešdiena </td><td>13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Ceturdiena </td><td>13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Piektdiena</td><td> 13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Sestdiena </td><td>13:00 - 20:00</td>
              </tr>
              <tr>
                <td>Svētdiena </td><td>13:00 - 20:00</td>
              </tr>
            </table>
          </div> */}
        </div>
        <MapWithAMarker
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC45edwcX_whgxbzkGoz0HIpOuetZZRJVM&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div className="map-block" />}
          mapElement={<div style={{ height: '100%' }} />}
          marker={markerPos}
          zoom={zoom}
        />
      </div>
    </div>
  );
};
export default IndexPage;



// WEBPACK FOOTER //
// ./src/imports/pages/contacts.jsx